import { Link, useNavigate, useParams } from "react-router";
import { Button } from "../../../app/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../app/components/ui/card";
import { PurchaseOrderForm } from "../components/PurchaseOrderForm";
import { usePurchaseOrder } from "../hooks/usePurchaseOrder";

export function PurchaseOrderEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { po, loading, error } = usePurchaseOrder(id);

  if (!id) {
    return <div className="p-6 text-destructive">Missing purchase order id.</div>;
  }

  if (loading || !po) {
    return (
      <div className="p-6">
        <div className="text-muted-foreground">{error ?? "Loading…"}</div>
      </div>
    );
  }

  if (po.status !== "DRAFT") {
    return (
      <div className="p-6 space-y-4">
        <div className="text-destructive">Only draft purchase orders can be edited.</div>
        <Button asChild variant="outline">
          <Link to={`/purchase-orders/${id}`}>Back to PO</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-3xl font-semibold text-foreground mb-1">Edit purchase order</h1>
          <p className="text-muted-foreground">PO #{id}</p>
        </div>
        <Button asChild variant="outline">
          <Link to={`/purchase-orders/${id}`}>Cancel</Link>
        </Button>
      </div>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle>Details</CardTitle>
          <CardDescription>Update dealer, notes, and line items.</CardDescription>
        </CardHeader>
        <CardContent>
          <PurchaseOrderForm
            mode="edit"
            purchaseOrderId={id}
            initialValues={{
              dealer_id: po.dealer.id,
              expected_delivery_date: po.expected_delivery_date ? po.expected_delivery_date.slice(0, 10) : "",
              notes: po.notes ?? "",
              items: po.items.map((it) => ({
                product_id: it.product_id,
                ordered_qty: it.ordered_qty,
                purchase_price: it.purchase_price,
              })),
            }}
            onSuccess={() => navigate(`/purchase-orders/${id}`)}
          />
        </CardContent>
      </Card>
    </div>
  );
}
